import React from 'react';
import {Text} from '@priority-software/priority-style-react';
import styles from './style.module.scss';
import {getHardcodedText, PurchasePlanningPromoText} from '../constants/purchasePlanningPromoText';

export const PurchasePlanningPromo = () => {
    return (
        <Text skin={'paragraph-2'}>
            {getHardcodedText(PurchasePlanningPromoText.bodyP1)}
            <Text
                skin={'paragraph-2'}
                fontWeight={'bold'}
                tag={'span'}
                componentClasses={styles.wordSpace}
            >
                {getHardcodedText(PurchasePlanningPromoText.menuName)}
            </Text>
            {getHardcodedText(PurchasePlanningPromoText.bodyP2)}
        </Text>
    );
};
